var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconOther = function SvgIconOther(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 48,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#6366F1",
    clipPath: "url(#icon-other_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.915 12.402a3.94 3.94 0 0 1-3.939-3.937V3H9.39a5.137 5.137 0 0 0-5.14 5.137v30.968a5.137 5.137 0 0 0 5.138 5.137h21.113a5.137 5.137 0 0 0 5.137-5.137V12.402h-4.724Z",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.64 12.402h-4.725a3.94 3.94 0 0 1-3.939-3.937V3l8.663 9.402Zm-6.457 6.582H9.473a.716.716 0 0 1 0-1.43h19.71a.716.716 0 0 1 0 1.43m0 4.271H9.473a.716.716 0 0 1 0-1.43h19.71a.716.716 0 0 1 0 1.43m0 4.27H9.473a.716.716 0 0 1 0-1.43h19.71a.715.715 0 0 1 0 1.43m0 4.269H9.473a.714.714 0 1 1 0-1.43h19.71a.716.716 0 0 1 0 1.43"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-other_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M4.25 3h31.5v42H4.25z"
  })))));
};
export default SvgIconOther;